import React from 'react';
import { Row, Col } from 'reactstrap';
import { AvField, AvGroup } from 'availity-reactstrap-validation'
import i18n from '../../../../../i18next';

const QuantityFields = (props) => {
    
    return (
        <Row>
            <Col xs={12} sm={6}>
                <AvGroup>
                    <AvField 
                        type="number" 
                        name="minimumQuantity" 
                        label={i18n.t('common:form.minQty')} 
                        min={0}
                        value={props.minimumQuantity}
                        onChange={props.changeState}
                        required={false}
                        errorMessage={i18n.t('common:validations.invalid')} 
                        onKeyPress={(e) => props.negativeDecimalsValidation(e)}
                    />
                </AvGroup>
            </Col>
            <Col xs={12} sm={6}>
                <AvGroup>
                    <AvField 
                        type="number" 
                        name="maximumQuantity" 
                        label={i18n.t('common:form.maxQty')} 
                        min={0}
                        value={props.maximumQuantity}
                        onChange={props.changeState}
                        required={false}
                        errorMessage={i18n.t('common:validations.invalid')}
                        onKeyPress={(e) => props.negativeDecimalsValidation(e)}
                    />
                </AvGroup>
            </Col>
        </Row>
    )
}

export default QuantityFields;


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/additionalInformation/QuantityFields.js